import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-audit-detailed-report-or1-dw",
  templateUrl: "./audit-detailed-report-or1-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditDetailedReportOr1DwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RISK_DETAILED_AUDIT_REPORT_DW;
  hideFilters = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID, HideFilters.PROJECT_NAME, HideFilters.PROJECT_NAME2];
}
